import React, { useState, useEffect } from "react";

import { Form, Formik, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { isAfter, parse, isValid, format, isEqual } from "date-fns";
import { HiSearch } from "react-icons/hi";

import {
  Flex,
  SimpleGrid,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  VStack,
  Textarea,
  Divider,
  Text,
  Icon,
  Tooltip,
  Link,
  Box,
  useBreakpointValue,
} from "@chakra-ui/react";
import { FaDownload } from "react-icons/fa";

import { CustomButton } from "../../../../components/CustomButton";
import { CustomSelectWField } from "../../../../components/CustomSelectWField";
import { CustomInputWField } from "../../../../components/CustomInputWField";
import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";
import CustomDropzone from "../../../../components/CustomDropzone";
import { PopoverGenero } from "../../../../components/PopoverGenero";

import {
  telefone as telMask,
  cpf,
  cpf as cpfMask,
  cep as cepMask,
  numeroEndereco,
  onlyNumbers,
  normalizeString,
  forNames,
} from "../../../../utils/masks";

import FiliacoesService from "../../../../../main/services/FiliacoesService";
import DadosGeograficosService from "../../../../../main/services/DadosGeograficosService";
import { FocusError } from "../../../../components/FocusError";
import {
  Permission,
  criancaFunc,
} from "../../../../../helpers/Funcionalidades";
import { IoHelpCircle } from "react-icons/io5";
import { getBase64 } from "../../../../components/Base64";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import { isValidCPF } from "../../../../utils/isValidCPF";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import { useAppContext } from "../../../../../Context/MessageContextProvider";

const suportedFormats = [
  ".png",
  ".bmp",
  ".tiff",
  ".jpg",
  ".jpeg",
  ".doc",
  ".docx",
  ".txt",
  ".dot",
  ".pdf",
  ".xml",
  ".xls",
  ".xlam",
  ".ods",
];

export const FiliacaoEditar = ({
  isOpen,
  onOpen,
  onClose,
  filiacoes,
  setFieldValue,
  selectedFiliacao,
  updateFromVisualizacao,
  dataNascimentoCA,
  isVisualizacao,
  idCrianca,
  secondOnClose,
  vinculoBlocked,
  idPJ,
}) => {
  const [hint, setHint] = useState(false);
  const [isVisual, setIsVisual] = useState(!!isVisualizacao);
  const [bairros, setBairros] = useState({ options: [], isLoading: false });
  const [municipios, setMunicipios] = useState({
    options: [],
    isLoading: false,
  });
  const { filiacaoEditarCr, setFiliacaoEditarCr } = useAppContext();
  const [isFocused, setIsFocused] = useState(false);
  const [isBlur, setIsBlur] = useState(false);
  const [invalidCPF, setInvalidCPF] = useState(false);
  const [estados, setEstados] = useState({ options: [], isLoading: false });
  const [estado, setEstado] = useState();
  const [municipio, setMunicipio] = useState();
  const [opcoesFiliacao, setOpcoesFiliacao] = useState([]);

  const isMobile = useBreakpointValue({ base: true, md: false });
  const [opcoesFalecido] = useState({
    options: [
      { id: 1, descricao: "Sim" },
      { id: 2, descricao: "Não" },
      { id: 3, descricao: "Sem Informação" },
    ],
    isLoading: false,
  });
  const { roleKeycloack, user } = useAuthProvider();
  //const [cpfExist, setCPFExist] = useState("");
  const [initialValues, setInitialValues] = useState({
    arquivoBase64: null,
    possuiAnexoCertidaoObito: "",
    certidaoObito: "",
    removeu: "",
    cep: "",
    complemento: "",
    cpf: "",
    email: "",
    dataNascimento: "",
    id: "",
    idBairro: "",
    idEstado: "",
    idMunicipio: "",
    falecido: "",
    informacoesComplementares: "",
    logradouro: "",
    nome: "",
    numeroIdentidade: "",
    numeroResidencia: "",
    pontoReferencia: "",
    possuiOutrosRelacionamentos: false,
    status: "",
    telefone: "",
    tipoFiliacao: "",
    idAnexo: "",
    falecidoDisabled: false,
    enderecoDisabled: false,
    disabledCPF: false,
  });

  const backAlert = () => {
    if (filiacaoEditarCr) {
      Swal.fire({
        title: "Tem certeza que deseja cancelar?",
        text: "As informações serão perdidas.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          onClose();
        }
      });
    } else {
      onClose();
    }
  };

  const handleGetEstados = () => {
    setEstados({ ...estados, isLoading: true });
    DadosGeograficosService.getEstados().then((res) => {
      setEstados({ options: res.data, isLoading: false });
    });
  };

  useEffect(() => {
    setMunicipios((prevState) => ({ ...prevState, isLoading: true }));
    if (estado) {
      DadosGeograficosService.pesquisarMunicipios(estado.id).then((res) => {
        setMunicipios({ options: res.data, isLoading: false });
      });
    } else {
      setMunicipios({ options: [], isLoading: false });
    }
  }, [estado]);

  useEffect(() => {
    setBairros((prevState) => ({ ...prevState, isLoading: true }));
    if (municipio) {
      DadosGeograficosService.pesquisarBairros(municipio.id).then((res) => {
        setBairros({ options: res.data, isLoading: false });
      });
    } else {
      setBairros({ options: [], isLoading: false });
    }
  }, [municipio]);

  useEffect(() => {
    const {
      cep,
      complemento,
      cpf,
      certidaoObito,
      possuiAnexoCertidaoObito,
      dataNascimento,
      email,
      falecido,
      filiacaoCriancas,
      idBairro,
      bairro,
      idEstado,
      estado,
      idMunicipio,
      municipio,
      informacoesComplementares,
      logradouro,
      numeroIdentidade,
      numeroResidencia,
      pontoReferencia,
      status,
      telefone,
      tipoFiliacao,
      idCriancaFiliacaoAcolhido,
      possuiOutrosRelacionamentos,
      ...resto
    } = selectedFiliacao;

    const blobData = new Blob([certidaoObito?.arquivoBase64], {
      type: certidaoObito?.arquivoTipo,
    });

    const fakeFile = new File([blobData], certidaoObito?.arquivoNome, {
      type: certidaoObito?.arquivoTipo,
    });

    setInitialValues({
      idAnexo: certidaoObito?.idAnexo ? certidaoObito?.idAnexo : "",
      certidaoObito: certidaoObito ? certidaoObito : "",
      possuiAnexoCertidaoObito: possuiAnexoCertidaoObito,
      arquivoBase64: possuiAnexoCertidaoObito ? fakeFile : null,
      cep: cep ? cepMask(cep) : "",
      complemento: complemento ? complemento : "",
      cpf: cpf ? cpfMask(cpf) : "",
      dataNascimento: dataNascimento
        ? isValid(dataNascimento)
          ? format(new Date(dataNascimento), "dd/MM/yyyy")
          : dataNascimento
        : "",
      email: email ? email : "",
      idBairro: bairro ? bairro : idBairro ? idBairro : "",
      idEstado: estado ? estado : idEstado ? idEstado : "",
      idMunicipio: municipio ? municipio : "",
      bairro: bairro ? bairro : "",
      estado: estado ? estado : "",
      municipio: municipio ? municipio : idMunicipio ? idMunicipio : "",
      informacoesComplementares: informacoesComplementares
        ? informacoesComplementares
        : "",
      logradouro: logradouro ? logradouro : "",
      numeroIdentidade: numeroIdentidade ? numeroIdentidade : "",
      numeroResidencia: numeroResidencia ? numeroResidencia : "",
      pontoReferencia: pontoReferencia ? pontoReferencia : "",
      status: status ? status : "",
      telefone: telefone ? telefone : "",
      falecido:
        falecido === "S" || falecido?.id === 1
          ? { id: 1, descricao: "Sim" }
          : falecido === "N" || falecido?.id === 2 || idCriancaFiliacaoAcolhido
          ? { id: 2, descricao: "Não" }
          : { id: 3, descricao: "Sem Informação" },
      tipoFiliacao:
        tipoFiliacao === "Pai"
          ? { label: "Pai", value: "pai" }
          : { label: "Mãe", value: "mae" },
      disabledCPF: idCriancaFiliacaoAcolhido ? true : false,
      falecidoDisabled: idCriancaFiliacaoAcolhido ? true : false,
      enderecoDisabled: idCriancaFiliacaoAcolhido ? true : false,
      idCriancaFiliacaoAcolhido: idCriancaFiliacaoAcolhido ? true : false,
      possuiOutrosRelacionamentos: possuiOutrosRelacionamentos
        ? possuiOutrosRelacionamentos
        : false,
      ...resto,
    });

    if (estado) {
      setEstado(estado);
    } else if (idEstado) {
      setEstado(idEstado);
    }
    if (municipio) {
      setMunicipio(municipio);
    } else if (idMunicipio) {
      setMunicipio(idMunicipio);
    }
    if (bairro) {
      setBairros(bairro);
    } else if (idBairro) {
      setBairros(idBairro);
    }
  }, [selectedFiliacao]);

  useEffect(() => {
    const paiDesSI = filiacoes.find((filiacao) => {
      return (
        filiacao.tipoFiliacao === "Pai" &&
        (filiacao.nome === "Desconhecido" ||
          normalizeString(filiacao.nome) === normalizeString("Sem informação"))
      );
    });
    const maeDesSI = filiacoes.find((filiacao) => {
      return (
        filiacao.tipoFiliacao === "Mãe" &&
        (filiacao.nome === "Desconhecida" ||
          normalizeString(filiacao.nome) === normalizeString("Sem informação"))
      );
    });

    let opcoesF = [
      { label: "Mãe", value: "mae" },
      { label: "Pai", value: "pai" },
    ];
    if (paiDesSI) {
      opcoesF = [{ label: "Mãe", value: "mae" }];
    }
    if (maeDesSI) {
      opcoesF = [{ label: "Pai", value: "pai" }];
    }
    setOpcoesFiliacao(opcoesF);
  }, [filiacoes]);

  const FocusErrorData = () => {
    const { values, setFieldError } = useFormikContext();

    useEffect(() => {
      const validateDate = () => {
        const { cpf } = values;

        if (cpf) {
          if (isValidCPF(cpf)) {
            setInvalidCPF(true);
            setFieldError("cpf", "");
          } else {
            setInvalidCPF(false);
            setFieldError("cpf", "");
          }
        }
      };

      validateDate();
    }, [values, values.dataNascimento, setFieldError]);

    return null;
  };

  const clearEndereco = (props) => {
    props.setFieldValue("logradouro", "");
    props.setFieldValue("numeroResidencia", "");
    props.setFieldValue("complemento", "");
    props.setFieldValue("cep", "");
    props.setFieldValue("pontoReferencia", "");
  };

  const handleGetCPF = async (cpf, props) => {
    if (cpf && cpf.length === 14 && !isVisual && initialValues.cpf !== cpf) {
      const resValid = await FiliacoesService.validarFiliacoesCPF(cpf);
      if (resValid.data.filiacao) {
        Swal.fire({
          title: "Atenção!",
          text: `O CPF ${cpf} pertence a ${resValid.data.filiacao.nome}. Deseja utilizar os mesmos dados?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#169499",
          cancelButtonColor: "#169499",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        }).then((result) => {
          if (result.isConfirmed) {
            const blobData = new Blob(
              [resValid?.data?.filiacao?.certidaoObito?.arquivoBase64],
              {
                type: resValid?.data?.filiacao?.certidaoObito?.arquivoTipo,
              }
            );

            const fakeFile = new File(
              [blobData],
              resValid?.data?.filiacao?.certidaoObito?.arquivoNome,
              {
                type: resValid?.data?.filiacao?.certidaoObito?.arquivoTipo,
              }
            );

            props.setFieldValue(
              "cep",
              resValid.data.filiacao.cep ? resValid.data.filiacao.cep : ""
            );
            props.setFieldValue(
              "complemento",
              resValid.data.filiacao.complemento
                ? resValid.data.filiacao.complemento
                : ""
            );
            props.setFieldValue(
              "cpf",
              resValid.data.filiacao.cpf
                ? cpfMask(resValid.data.filiacao.cpf)
                : ""
            );
            props.setFieldValue(
              "email",
              resValid.data.filiacao.email ? resValid.data.filiacao.email : ""
            );
            props.setFieldValue(
              "dataNascimento",
              resValid.data.filiacao.dataNascimento
                ? isValid(resValid.data.filiacao.dataNascimento)
                  ? format(
                      new Date(resValid.data.filiacao.dataNascimento),
                      "dd/MM/yyyy"
                    )
                  : resValid.data.filiacao.dataNascimento
                : ""
            );

            props.setFieldValue(
              "falecido",
              resValid.data.filiacao.falecido === "N" ||
                resValid.data.filiacao.falecido?.id === 2 ||
                resValid?.data?.filiacao?.idCriancaFiliacaoAcolhido
                ? { id: 2, descricao: "Não" }
                : resValid.data.filiacao.falecido === "S" ||
                  resValid.data.filiacao.falecido?.id === 1
                ? { id: 1, descricao: "Sim" }
                : { id: 3, descricao: "Sem Informação" } || ""
            );
            props.setFieldValue("id", resValid.data.filiacao.id || "");
            props.setFieldValue(
              "idBairro",
              resValid.data.filiacao.bairro
                ? resValid.data.filiacao.bairro
                : resValid.data.filiacao.idBairro
                ? resValid.data.filiacao.idBairro
                : ""
            );
            props.setFieldValue(
              "idEstado",
              resValid.data.filiacao.estado
                ? resValid.data.filiacao.estado
                : resValid.data.filiacao.idEstado
                ? resValid.data.filiacao.idEstado
                : ""
            );
            props.setFieldValue(
              "idMunicipio",
              resValid.data.filiacao.municipio
                ? resValid.data.filiacao.municipio
                : resValid.data.filiacao.idMunicipio
                ? resValid.data.filiacao.idMunicipio
                : ""
            );
            props.setFieldValue(
              "bairro",
              resValid.data.filiacao.bairro ? resValid.data.filiacao.bairro : ""
            );
            props.setFieldValue(
              "estado",
              resValid.data.filiacao.estado ? resValid.data.filiacao.estado : ""
            );
            props.setFieldValue(
              "municipio",
              resValid.data.filiacao.municipio
                ? resValid.data.filiacao.municipio
                : ""
            );

            props.setFieldValue(
              "informacoesComplementares",
              resValid.data.filiacao.informacoesComplementares
                ? resValid.data.filiacao.informacoesComplementares
                : ""
            );
            props.setFieldValue(
              "logradouro",
              resValid.data.filiacao.logradouro
                ? resValid.data.filiacao.logradouro
                : ""
            );
            props.setFieldValue("nome", resValid.data.nome || "");
            props.setFieldValue(
              "numeroIdentidade",
              resValid.data.filiacao.numeroIdentidade
                ? resValid.data.filiacao.numeroIdentidade
                : ""
            );
            props.setFieldValue(
              "numeroResidencia",
              resValid.data.filiacao.numeroResidencia
                ? resValid.data.filiacao.numeroResidencia
                : ""
            );
            props.setFieldValue(
              "arquivoBase64",
              resValid.data.filiacao.possuiAnexoCertidaoObito ? fakeFile : null
            );
            props.setFieldValue(
              "pontoReferencia",
              resValid.data.filiacao.pontoReferencia
                ? resValid.data.filiacao.pontoReferencia
                : ""
            );
            props.setFieldValue(
              "status",
              resValid.data.filiacao.status ? resValid.data.filiacao.status : ""
            );

            props.setFieldValue(
              "telefone",
              resValid.data.filiacao.telefone
                ? resValid.data.filiacao.telefone
                : ""
            );

            props.setFieldValue(
              "tipoFiliacao",
              selectedFiliacao.tipoFiliacao === "Pai"
                ? { label: "Pai", value: "pai" }
                : { label: "Mãe", value: "mae" }
            );
            props.setFieldValue(
              "disabledCPF",
              resValid?.data?.filiacao?.idCriancaFiliacaoAcolhido ? true : false
            );
            props.setFieldValue(
              "falecidoDisabled",
              resValid?.data?.filiacao?.idCriancaFiliacaoAcolhido ? true : false
            );
            props.setFieldValue(
              "enderecoDisabled",
              resValid?.data?.filiacao?.idCriancaFiliacaoAcolhido ? true : false
            );
            props.setFieldValue(
              "disabledCPF",
              resValid?.data?.filiacao?.idCriancaFiliacaoAcolhido ? true : false
            );
          } else {
            props.setFieldValue("enderecoDisabled", "");
            props.setFieldValue("cpf", "");
          }
          props.setFieldValue(
            "idCriancaFiliacaoAcolhido",
            resValid?.data?.filiacao?.idCriancaFiliacaoAcolhido
          );
        });
      }
    }
  };

  const schema = Yup.object().shape(
    {
      cep: Yup.string(),
      arquivoBase64: Yup.mixed()
        .nullable()
        .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
          if (!value) {
            return true;
          } else {
            return value?.size <= 10000000;
          }
        })
        .test("fileType", "Anexar uma extensão válida.", (value) => {
          if (
            value === null ||
            !value?.path ||
            typeof value.path.toString !== "function"
          ) {
            return true;
          } else {
            const filePath = value.path.toString().toLowerCase();

            let haveFormat = false;
            suportedFormats.forEach((format) => {
              if (filePath.includes(format)) {
                haveFormat = true;
              }
            });
            return haveFormat;
          }
        }),
      complemento: Yup.string(),
      cpf: Yup.string()
        .test("unicidade", `Filiação já cadastrada na ficha.`, (value) => {
          if (value) {
            const found = filiacoes
              .filter(
                (filiacao) =>
                  filiacao.id !== selectedFiliacao.id ||
                  (filiacao?.cpf?.replace(/[.-]|[.-](?=.)/g, "").trim() ===
                    selectedFiliacao?.cpf
                      ?.replace(/[.-]|[.-](?=.)/g, "")
                      .trim() &&
                    selectedFiliacao?.cpf
                      ?.replace(/[.-]|[.-](?=.)/g, "")
                      .trim() !== value?.replace(/[.-]|[.-](?=.)/g, "").trim())
              )
              .find((filiacao) => {
                if (filiacao.cpf) {
                  return (
                    filiacao?.cpf?.replace(/[.-]|[.-](?=.)/g, "").trim() ===
                      selectedFiliacao?.cpf
                        ?.replace(/[.-]|[.-](?=.)/g, "")
                        .trim() ||
                    filiacao?.cpf?.replace(/[.-]|[.-](?=.)/g, "").trim() ===
                      value?.replace(/[.-]|[.-](?=.)/g, "").trim()
                  );
                } else {
                  return false;
                }
              });
            if (!!found) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        })
        .test("cpfValido", "", (value) => {
          if (!isValidCPF(value)) {
            return false;
          } else {
            return true;
          }
        }),
      email: Yup.string().trim().email("Email inválido!"),
      dataNascimento: Yup.string()
        .nullable()
        .test("validDate", "Data inválida!", (value) => {
          if (!!value) {
            if (value.length === 10) {
              return isValid(parse(value, "dd/MM/yyyy", new Date()));
            } else {
              return false;
            }
          } else {
            return true;
          }
        })
        .test(
          "dataNascimentoAfterToday",
          "A data informada não pode ser uma data futura!",
          (value) => {
            if (!value) {
              return true;
            } else {
              return !isAfter(
                parse(value, "dd/MM/yyyy", new Date()),
                new Date()
              );
            }
          }
        )
        .test(
          "dataNascimentoAfter",
          "A data informada não pode ser posterior ao nascimento da criança/adolescente!",
          (value) => {
            if (updateFromVisualizacao && !!dataNascimentoCA) {
              return !isAfter(
                parse(value, "dd/MM/yyyy", new Date()),
                new Date(dataNascimentoCA)
              );
            } else {
              return true;
            }
          }
        )
        .test(
          "dataNascimentoEqual",
          "A data informada não pode ser igual à data de nascimento da criança/adolescente!",
          (value) => {
            if (updateFromVisualizacao && !!dataNascimentoCA) {
              return !isEqual(
                parse(value, "dd/MM/yyyy", new Date()),
                new Date(dataNascimentoCA)
              );
            } else {
              return true;
            }
          }
        ),
      falecido: Yup.object().required("Este campo é obrigatório!"),
      id: Yup.string(),
      idBairro: Yup.mixed().when("idMunicipio", {
        is: (municipio) =>
          municipio ? municipio.id === 3233 || municipio.id === 3215 : false,
        then: Yup.mixed().required("Este campo é obrigatório!").nullable(),
      }),
      idEstado: Yup.mixed(),
      idMunicipio: Yup.mixed(),
      informacoesComplementares: Yup.string(),
      logradouro: Yup.string(),
      nome: Yup.string()
        .required("Este campo é obrigatório!")
        .trim("Este campo é obrigatório!"),
      numeroIdentidade: Yup.string(),
      numeroResidencia: Yup.number(),
      pontoReferencia: Yup.string(),
      status: Yup.string(),
      telefone: Yup.string()
        .min(14, "Telefone inválido!")
        .max(15, "Telefone inválido!"),
      tipoFiliacao: Yup.object()
        .nullable()
        .required("Este campo é obrigatório!"),
    },
    [
      ["cpf", "nome"],
      ["nome", "cpf"],
    ]
  );

  const getCertidaoDownload = (idFiliacao, idDocumento) => {
    FiliacoesService.getCertidaoObitoDownload(idFiliacao, idDocumento)
      .then((res) => {
        const downloadUrl = res.config.url;
        window.open(downloadUrl, "_blank");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSubmit = (values, actions) => {
    setTimeout(async () => {
      const {
        tipoFiliacao,
        nome,
        dataNascimento,
        falecido,
        cpf,
        numeroIdentidade,
        email,
        informacoesComplementares,
        idEstado,
        idMunicipio,
        idBairro,
        estado,
        municipio,
        bairro,
        logradouro,
        complemento,
        pontoReferencia,
        id,
        certidaoObito,
        possuiAnexoCertidaoObito,
        removeu,
        local,
        arquivoBase64,
        ...resto
      } = values;

      const nameImage = values?.arquivoBase64?.name;
      const typeImage = values?.arquivoBase64?.type;

      let arquivoBase64Value = arquivoBase64;

      if (arquivoBase64 instanceof File) {
        await new Promise((resolve) => {
          getBase64(values?.arquivoBase64, (base64Data) => {
            arquivoBase64Value = base64Data;
            resolve();
          });
        });
      }

      const anexoCertidaoObito = {
        arquivoBase64: arquivoBase64Value
          ? arquivoBase64Value.split(",")[1]
          : possuiAnexoCertidaoObito && removeu
          ? certidaoObito?.arquivoBase64.split(",")[1]
          : "",
        arquivoNome: nameImage ? nameImage : "",
        arquivoTipo: typeImage ? typeImage : "",
        idAnexo: !possuiAnexoCertidaoObito
          ? 0
          : possuiAnexoCertidaoObito && removeu
          ? certidaoObito?.idAnexo
          : possuiAnexoCertidaoObito && !removeu
          ? certidaoObito?.idAnexo
          : 0,
      };

      const isFalecido = falecido === "S" || falecido?.id === 1;
      const naoFalecido = falecido !== "S" && falecido?.id !== 1;

      if (arquivoBase64 && isFalecido) {
        anexoCertidaoObito.remover = false;
        anexoCertidaoObito.atualizar = true;
      } else if (possuiAnexoCertidaoObito && naoFalecido) {
        anexoCertidaoObito.arquivoBase64 = "";
        anexoCertidaoObito.remover = true;
        anexoCertidaoObito.atualizar = true;
      } else {
        anexoCertidaoObito.remover = true;
        anexoCertidaoObito.atualizar = true;
      }

      const valuesToSend = {
        ...resto,
        anexoCertidaoObito: anexoCertidaoObito ? anexoCertidaoObito : "",
        tipoFiliacao: tipoFiliacao ? tipoFiliacao.label : "",
        nome: nome ? nome.trim() : "",
        dataNascimento: dataNascimento
          ? parse(dataNascimento, "dd/MM/yyyy", new Date()).toISOString()
          : "",
        falecido: falecido?.id === 1 ? "S" : falecido?.id === 2 ? "N" : null,

        cpf: cpf ? cpf?.replace(/\D/g, "").trim() : "",
        numeroIdentidade: numeroIdentidade ? numeroIdentidade.trim() : "",
        email: email ? email.trim() : "",
        informacoesComplementares: informacoesComplementares
          ? informacoesComplementares.trim()
          : "",
        idEstado: idEstado ? idEstado?.id : "",
        idMunicipio: idMunicipio ? idMunicipio?.id : "",
        idBairro: idBairro ? idBairro?.id : "",
        logradouro: logradouro ? logradouro.trim() : "",
        complemento: complemento ? complemento.trim() : "",
        pontoReferencia: pontoReferencia ? pontoReferencia.trim() : "",
      };

      delete valuesToSend.arquivoBase64;
      delete valuesToSend.possuiAnexoCertidaoObito;
      delete valuesToSend.removeu;
      delete valuesToSend.certidaoObito;

      if (updateFromVisualizacao) {
        FiliacoesService.editarFiliacao(
          selectedFiliacao.id,
          valuesToSend,
          idCrianca
        )
          .then((res) => {
            Swal.fire({
              title: "Sucesso!",
              text: "Registro atualizado com sucesso!",
              icon: "success",
              confirmButtonText: "Continuar",
              confirmButtonColor: "#169499",
            }).then(function () {
              onClose();
            });
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data) {
                if (error.response.data.message) {
                  const errors = JSON.parse(error.response.data.message);
                  for (let key in errors) {
                    actions.setFieldError(
                      key.toString().slice(key.toString().indexOf(".") + 1),
                      errors[key]
                    );
                  }
                } else if (error.response.data.apierror) {
                  if (error.response.data.apierror.subErrors) {
                    error.response.data.apierror.subErrors.forEach((erro) => {
                      actions.setFieldError(
                        erro.field
                          .toString()
                          .slice(erro.field.toString().indexOf(".") + 1),
                        erro.message
                      );
                    });
                  }
                }
              }
            } else {
              console.log(error);
            }
          });
      } else {
        if (id >= 0) {
          valuesToSend["id"] = id;
        }

        const executeValidate = () => {
          if (secondOnClose) {
            secondOnClose({
              ...values,
              tipoFiliacao: values.tipoFiliacao
                ? values.tipoFiliacao.label
                : "",
              bairro: values.idBairro ? values.idBairro : "",
              municipio: values.idMunicipio ? values.idMunicipio : "",
              estado: values.idEstado ? values.idEstado : "",
              falecido:
                values.falecido.id === 1
                  ? "S"
                  : values.falecido.id === 2
                  ? "N"
                  : null,
            });
          } else {
            if (valuesToSend.tipoFiliacao === "Pai") {
              setFieldValue("situacaoPai", "");
            } else {
              setFieldValue("situacaoMae", "");
            }

            setFieldValue(
              "filiacoes",
              filiacoes.map((filiacao) => {
                if (filiacao.id === selectedFiliacao.id) {
                  return {
                    ...values,
                    tipoFiliacao: values.tipoFiliacao
                      ? values.tipoFiliacao.label
                      : "",
                    falecido:
                      values.falecido?.id === 1 || values?.falecido === "S"
                        ? "S"
                        : values.falecido?.id === 2 || values?.falecido === "N"
                        ? "N"
                        : null,
                    bairro: values.idBairro ? values.idBairro : "",
                    municipio: values.idMunicipio ? values.idMunicipio : "",
                    estado: values.idEstado ? values.idEstado : "",
                  };
                } else {
                  return filiacao;
                }
              })
            );
            onClose();
          }
        };

        if (idCrianca) {
          FiliacoesService.validar([valuesToSend], idCrianca)
            .then((res) => {
              executeValidate();
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.data) {
                  if (error.response.data.message) {
                    const errors = JSON.parse(error.response.data.message);
                    for (let key in errors) {
                      actions.setFieldError(
                        key.toString().slice(key.toString().indexOf(".") + 1),
                        errors[key]
                      );
                    }
                  } else if (error.response.data.apierror) {
                    if (error.response.data.apierror.subErrors) {
                      error.response.data.apierror.subErrors.forEach((erro) => {
                        actions.setFieldError(
                          erro.field
                            .toString()
                            .slice(erro.field.toString().indexOf(".") + 1),
                          erro.message
                        );
                      });
                    }
                  }
                }
              } else {
                console.log(error);
              }
            });
        } else {
          executeValidate();
        }
      }

      actions.setSubmitting(false);
    }, 200);
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="6xl"
        scrollBehavior={"inside"}
      >
        <ModalOverlay />
        <ModalContent
          p={{ base: "5px", sm: "15px", md: "25px" }}
          w={{ base: "100%", lg: "70%" }}
          bgColor="#FFF"
        >
          <ModalHeader
            p="0px"
            fontWeight={700}
            fontSize="14px"
            lineHeight="19.6px"
            color="#169499"
          >
            {isVisual
              ? "Visualizar Filiação".toUpperCase()
              : "Editar Filiação".toUpperCase()}
          </ModalHeader>
          <ModalBody
            p="0px"
            mt="25px"
            minH={{ base: "0px", md: "200px" }}
            pl="1px"
          >
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
              enableReinitialize
            >
              {(props) => (
                <Form style={{ width: "100%", paddingBottom: "5px" }}>
                  {setFiliacaoEditarCr(
                    hasFormChanged(initialValues, props.values)
                  )}
                  <FocusError />
                  <FocusErrorData />
                  <Grid templateColumns="repeat(4, 1fr)" w="100%" gap={"15px"}>
                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomSelectWField
                        fieldName="tipoFiliacao"
                        label="Vínculo*"
                        placeholder="Selecione o Vínculo"
                        options={opcoesFiliacao}
                        onChange={(value) => {
                          props.setFieldValue("tipoFiliacao", value);
                        }}
                        isDisabled={isVisual || vinculoBlocked}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 2 }}>
                      <CustomInputWField
                        fieldName="nome"
                        label="Nome*"
                        placeholder="Informe o Nome"
                        onChange={(e) =>
                          props.setFieldValue("nome", forNames(e.target.value))
                        }
                        isDisabled={isVisual}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <VStack alignItems="flex-start">
                        <CustomDatepickerWField
                          fieldName="dataNascimento"
                          label="Data de Nascimento"
                          placeholder="DD/MM/AAAA"
                          isDisabled={isVisual}
                        />
                      </VStack>
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <Flex gap={4}>
                        <Box w="224.25px">
                          <CustomSelectWField
                            fieldName="falecido"
                            label="É falecido? *"
                            placeholder="Selecione se é falecido"
                            getOptionLabel={(option) => option.descricao}
                            getOptionValue={(option) => option.id}
                            options={opcoesFalecido.options}
                            onChange={(value) => {
                              props.setFieldValue(
                                "falecido",
                                value ? value : ""
                              );
                            }}
                            isDisabled={
                              isVisual ||
                              selectedFiliacao?.falecidoDisabled ||
                              props?.values?.falecidoDisabled
                            }
                          />
                        </Box>

                        {props?.values?.falecido?.id === 1 &&
                          isVisual &&
                          props.values.possuiAnexoCertidaoObito && (
                            <Flex justifyContent="end" flexDir="column">
                              <Text
                                color="#5F6377"
                                whiteSpace={"nowrap"}
                                fontWeight="500"
                                fontSize="14px"
                                lineHeight="19.6px"
                              >
                                Baixar Certidão de Óbito
                              </Text>
                              <Flex justifyContent={"center"}>
                                <button
                                  type="button"
                                  onClick={() =>
                                    getCertidaoDownload(
                                      props.values.id,
                                      props.values.idAnexo
                                    )
                                  }
                                >
                                  <Icon
                                    aria-label="Download"
                                    color="#006064"
                                    as={FaDownload}
                                    boxSize="18px"
                                    _hover={{ cursor: "pointer" }}
                                  />
                                </button>
                              </Flex>
                            </Flex>
                          )}
                      </Flex>
                    </GridItem>
                    <GridItem colSpan={{ base: 4, lg: 3 }} />
                    {props?.values?.falecido?.id === 1 && !isVisual && (
                      <>
                        <GridItem colSpan={{ base: 4, lg: 1 }}>
                          <Flex mt={"15px"}>
                            <CustomDropzone
                              width={"180px"}
                              formProps={props}
                              title={`Anexar Certidão de Óbito`}
                              fieldName="arquivoBase64"
                              height="42px"
                              isDisabled={isVisual}
                              titleText="Informe o número da guia"
                              setAnexoNaoEditado={() =>
                                props.setFieldValue("removeu", true)
                              }
                            />
                          </Flex>
                        </GridItem>
                        <GridItem
                          alignItems="center"
                          display="flex"
                          colSpan={{ base: 1, lg: 1 }}
                        >
                          <Flex
                            mt={{ base: "20px", md: "40px" }}
                            alignItems={"center"}
                            border={"solid 2px"}
                            rounded={"full"}
                            borderColor={"#DDEBEA"}
                            px={1}
                          >
                            <Flex alignItems={"center"} gap={2}>
                              <Link
                                whiteSpace={"nowrap"}
                                href={
                                  "https://www4.tjrj.jus.br/Portal-Extrajudicial/CNO/"
                                }
                                isExternal
                              >
                                <Flex gap={2}>
                                  <HiSearch size={20} color="#5F6377" />

                                  <Text
                                    color="#5F6377"
                                    fontWeight="500"
                                    fontSize="14px"
                                    lineHeight="19.6px"
                                  >
                                    Buscar Certidão de Óbito
                                  </Text>
                                </Flex>
                              </Link>
                              {isMobile ? (
                                <PopoverGenero
                                  isOpen={hint}
                                  setIsOpen={setHint}
                                  flex={true}
                                  handleClick={() => setHint(!hint)}
                                  labelTextoGenero={
                                    "Informações sobre registros de nascimentos e óbitos podem ser consultadas de forma on-line e gratuita pela página da Corregedoria Geral da Justiça do Tribunal de Justiça do Rio de Janeiro, através do Portal Extrajudicial. A plataforma permite que o usuário verifique de forma rápida em qual Serviço Extrajudicial se encontra o registro de nascimento ou óbito, facilitando assim a obtenção de segundas vias de certidões. O sistema permite aos cidadãos, aos órgãos judiciais e demais órgãos públicos a obtenção de informações relativas a registros de nascimento e óbito realizados em todo o estado desde agosto de 2007."
                                  }
                                />
                              ) : (
                                <Tooltip
                                  width={"90%"}
                                  textAlign="justify"
                                  label="Informações sobre registros de nascimentos e óbitos podem ser consultadas de forma on-line e gratuita pela página da Corregedoria Geral da Justiça do Tribunal de Justiça do Rio de Janeiro, através do Portal Extrajudicial. A plataforma permite que o usuário verifique de forma rápida em qual Serviço Extrajudicial se encontra o registro de nascimento ou óbito, facilitando assim a obtenção de segundas vias de certidões.
          O sistema permite aos cidadãos, aos órgãos judiciais e demais órgãos públicos a obtenção de informações relativas a registros de nascimento e óbito realizados em todo o estado desde agosto de 2007."
                                >
                                  <Flex>
                                    <Icon
                                      aria-label="Aviso de pendente"
                                      color="#6B6C71"
                                      as={IoHelpCircle}
                                      boxSize="20px"
                                    />
                                  </Flex>
                                </Tooltip>
                              )}
                            </Flex>
                          </Flex>
                        </GridItem>
                      </>
                    )}
                  </Grid>
                  <Divider mt="15px" />
                  <Text
                    color="#5F6377"
                    fontWeight={500}
                    fontSize="14px"
                    lineHeight="19.6px"
                    mt="15px"
                  >
                    Endereço
                  </Text>

                  <Grid
                    templateColumns="repeat(9, 1fr)"
                    gap="15px"
                    mt="15px"
                    w="100%"
                  >
                    <GridItem colSpan={{ base: 9, lg: 3 }}>
                      <CustomSelectWField
                        fieldName="idEstado"
                        label="Estado"
                        placeholder="Escolha o Estado"
                        getOptionLabel={(option) => option.nome}
                        getOptionValue={(option) => option.id}
                        isLoading={estados.isLoading}
                        options={estados.options}
                        onChange={(value) => {
                          if (value && props.values.idEstado) {
                            if (value.nome !== props.values.idEstado.nome) {
                              props.setFieldValue("idMunicipio", "");
                              props.setFieldValue("idBairro", "");
                            }
                          } else {
                            props.setFieldValue("idMunicipio", "");
                            props.setFieldValue("idBairro", "");
                          }
                          setEstado(value);
                          setMunicipio(false);
                          props.setFieldValue("idEstado", value);
                          clearEndereco(props);
                        }}
                        onFocus={
                          estados.options.length === 0 ? handleGetEstados : null
                        }
                        isDisabled={
                          isVisual ||
                          selectedFiliacao?.enderecoDisabled ||
                          props?.values?.enderecoDisabled
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 3 }}>
                      <CustomSelectWField
                        fieldName="idMunicipio"
                        label="Cidade"
                        placeholder="Escolha a Cidade"
                        getOptionLabel={(option) => option.nome}
                        getOptionValue={(option) => option.id}
                        isLoading={municipios.isLoading}
                        options={municipios.options}
                        onChange={(value) => {
                          setMunicipio(value);
                          props.setFieldValue("idMunicipio", value);
                          props.setFieldValue("idBairro", "");
                          clearEndereco(props);
                        }}
                        isDisabled={
                          isVisual ||
                          selectedFiliacao?.enderecoDisabled ||
                          props?.values?.enderecoDisabled
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 3 }}>
                      <CustomSelectWField
                        fieldName={"idBairro"}
                        label={`Bairro${
                          props?.values?.idMunicipio?.id === 3233 ||
                          props?.values?.idMunicipio?.id === 3215
                            ? "*"
                            : ""
                        }`}
                        placeholder="Escolha o Bairro"
                        getOptionLabel={(option) => option.nome}
                        getOptionValue={(option) => option.id}
                        isLoading={bairros.isLoading}
                        options={bairros.options}
                        onChange={(value) => {
                          props.setFieldValue("idBairro", value);
                          !value && clearEndereco(props);
                        }}
                        isDisabled={
                          isVisual ||
                          selectedFiliacao?.enderecoDisabled ||
                          props?.values?.enderecoDisabled
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 7 }}>
                      <CustomInputWField
                        fieldName="logradouro"
                        label="Logradouro"
                        placeholder="Informe o Logradouro"
                        isDisabled={
                          isVisual ||
                          selectedFiliacao?.enderecoDisabled ||
                          props?.values?.enderecoDisabled ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 2 }}>
                      <CustomInputWField
                        fieldName="numeroResidencia"
                        label="Número"
                        placeholder="Informe o Número"
                        maxLength={14}
                        onChange={(e) =>
                          props.setFieldValue(
                            "numeroResidencia",
                            numeroEndereco(e.target.value)
                          )
                        }
                        isDisabled={
                          isVisual ||
                          selectedFiliacao?.enderecoDisabled ||
                          props?.values?.enderecoDisabled ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 7 }}>
                      <CustomInputWField
                        fieldName="complemento"
                        label="Complemento"
                        placeholder="Informe o Complemento"
                        isDisabled={
                          isVisual ||
                          selectedFiliacao?.enderecoDisabled ||
                          props?.values?.enderecoDisabled ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 2 }}>
                      <CustomInputWField
                        fieldName="cep"
                        label="CEP"
                        placeholder="Informe o CEP"
                        maxLength={9}
                        onChange={(e) =>
                          props.setFieldValue("cep", cepMask(e.target.value))
                        }
                        isDisabled={
                          isVisual ||
                          selectedFiliacao?.enderecoDisabled ||
                          props?.values?.enderecoDisabled ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 9 }}>
                      <CustomInputWField
                        fieldName="pontoReferencia"
                        label="Ponto de Referência"
                        placeholder="Informe o Ponto de Referência"
                        isDisabled={
                          isVisual ||
                          selectedFiliacao?.enderecoDisabled ||
                          props?.values?.enderecoDisabled ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro
                        }
                      />
                    </GridItem>
                  </Grid>

                  <Divider mt="15px" />
                  <Grid
                    templateColumns="repeat(4, 1fr)"
                    gap="15px"
                    w="100%"
                    mt="15px"
                  >
                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomInputWField
                        fieldName="cpf"
                        label="CPF"
                        placeholder="000.000.000-00"
                        maxLength={14}
                        onChange={(e) => {
                          props.setFieldValue("cpf", cpf(e.target.value));
                          //setCPFExist(cpf(e.target.value));
                          handleGetCPF(cpfMask(e.target.value), props);
                        }}
                        isDisabled={
                          isVisual ||
                          selectedFiliacao?.disabledCPF ||
                          (props?.values?.disabledCPF &&
                            selectedFiliacao?.cpf) ||
                          (selectedFiliacao.cpf &&
                            props.values.possuiOutrosRelacionamentos)
                        }
                        setIsFocused={setIsFocused}
                        setIsBlur={
                          props?.values?.cpf?.replace(/[^\d]+/g, "").length ===
                            11 && setIsBlur
                        }
                      />
                      {props.values.cpf &&
                        !isFocused &&
                        !invalidCPF &&
                        !isBlur && (
                          <Text
                            color="red"
                            opacity={0.8}
                            mt={2}
                            fontSize="12px"
                          >
                            Informar um CPF válido
                          </Text>
                        )}
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomInputWField
                        fieldName="numeroIdentidade"
                        label="Identidade"
                        placeholder="Informe a Identidade"
                        maxLength={15}
                        onChange={(e) =>
                          props.setFieldValue(
                            "numeroIdentidade",
                            onlyNumbers(e.target.value)
                          )
                        }
                        isDisabled={isVisual}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomInputWField
                        fieldName="telefone"
                        label="Telefone"
                        placeholder="(99) 99999-9999"
                        maxLength={15}
                        onChange={(e) =>
                          props.setFieldValue(
                            "telefone",
                            telMask(e.target.value)
                          )
                        }
                        isDisabled={isVisual}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomInputWField
                        fieldName="email"
                        label="E-mail"
                        placeholder="Informe o e-mail"
                        isDisabled={isVisual}
                      />
                    </GridItem>

                    <GridItem colSpan={4}>
                      <Field name="informacoesComplementares">
                        {({ field, form }) => (
                          <Flex flexDir="column" position="relative">
                            <FormControl
                              isInvalid={
                                form.errors.informacoesComplementares &&
                                form.touched.informacoesComplementares
                              }
                            >
                              <FormLabel
                                color="#5F6377"
                                fontWeight="500"
                                fontSize="14px"
                                lineHeight="19.6px"
                                htmlFor="informacoesComplementares"
                              >
                                Informações Complementares
                              </FormLabel>
                              <Textarea
                                {...field}
                                name="informacoesComplementares"
                                id="informacoesComplementares"
                                backgroundColor="#fff"
                                autoComplete="off"
                                border="1px solid #D7D8DE"
                                placeholder="Informe as Informações Complementares"
                                maxLength={255}
                                isDisabled={isVisual}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value.length <= 255) {
                                    form.setFieldValue(
                                      "informacoesComplementares",
                                      value
                                    );
                                  }
                                }}
                              />
                              <Text
                                zIndex={10}
                                fontSize="sm"
                                position="absolute"
                                bottom="5px"
                                right="15px"
                                color={
                                  field.value.length === 255 ? "red" : "gray"
                                }
                              >
                                {field.value.length}/255
                              </Text>
                              <FormErrorMessage>
                                {form.errors.informacoesComplementares}
                              </FormErrorMessage>
                            </FormControl>
                          </Flex>
                        )}
                      </Field>
                    </GridItem>
                  </Grid>

                  <Flex justifyContent="end">
                    <SimpleGrid
                      mt="25px"
                      columns={2}
                      spacing="15px"
                      w={{ base: "100%", lg: "40%" }}
                    >
                      {isVisual ? (
                        <CustomButton onClick={onClose} label="Voltar" />
                      ) : (
                        <CustomButton onClick={backAlert} label="Cancelar" />
                      )}
                      {isVisual ? (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={criancaFunc.cadastrarEditarFiliacao}
                          user={user}
                          id={idPJ}
                          visualizar={true}
                        >
                          <CustomButton
                            onClick={(e) => {
                              e.preventDefault();
                              setIsVisual(false);
                            }}
                            label="Editar"
                          />
                        </Permission>
                      ) : (
                        <CustomButton
                          type="submit"
                          translate="no"
                          isLoading={props.isSubmitting}
                          label="Salvar"
                        />
                      )}
                    </SimpleGrid>
                  </Flex>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
